import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

/** What the user chose in the inactivity warning. */
export type InactivityChoice = 'stay' | 'logout';

/**
 * The warning shown before the idle logout. `SessionIdleService` opens it and counts `secondsLeft`
 * down; the modal fetches nothing and only reports the choice.
 */
@Component({
  selector: 'szz-inactivity',
  standalone: true,
  templateUrl: './inactivity.component.html',
  styleUrls: ['./inactivity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InactivityComponent {
  private readonly activeModal = inject(NgbActiveModal);

  /** Set by `SessionIdleService` on every tick of the countdown. */
  readonly secondsLeft = signal(0);

  protected stay(): void {
    this.activeModal.close('stay' satisfies InactivityChoice);
  }

  protected logout(): void {
    this.activeModal.close('logout' satisfies InactivityChoice);
  }
}
